/**
 * Adds mutations for handling submitting/updating.
 *
 * @returns {Function} that will take a module and apply the plugin.
 */
export default function() {
  return function(module) {
    const uName = module.name.toUpperCase();
    const SUBMIT_INIT = `${uName}_SUBMIT_INIT`;
    const SUBMIT_DONE = `${uName}_SUBMIT_DONE`;
    module.addMutationTypes([SUBMIT_INIT, SUBMIT_DONE]);

    const state = {
      submitting: false
    };

    const mutations = {
      [SUBMIT_INIT](state) {
        state.submitting = true;
      },
      [SUBMIT_DONE](state) {
        state.submitting = false;
      }
    };

    return module.extend({ state, mutations });
  };
}
